/**
 * Customer Detail → "Points Notifications": how one LoyaltyPointsNotifications row reads.
 * Support uses it to answer "why did I (not) get a warning?", so skipped and undelivered
 * rows say why.
 */

export const formatDay = (value) =>
  value ? new Date(value).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "-";

export const notificationLabel = (n) => {
  if (n.kind === "expiry_warning") return `Expiry warning · ${n.thresholdDays} days`;
  if (n.kind === "inactivity") return "Inactivity reminder";
  if (n.kind === "expired") return "Points expired";
  return n.kind;
};

export const notificationAbout = (n) => {
  if (!n.aboutDate) return "—";
  return n.kind === "inactivity" ? `Purchase ${formatDay(n.aboutDate)}` : `Expiry ${formatDay(n.aboutDate)}`;
};

export const notificationDelivery = (n) => {
  if (n.suppressed) {
    // A warning step is skipped when a nearer one went out the same day; an inactivity
    // reminder when the expiry warnings already cover the balance.
    return n.kind === "inactivity" ? "Skipped · expiry warnings cover it" : "Skipped · nearer warning sent";
  }
  if (!n.channels.length) return "Not delivered · no device";
  return n.channels.map((ch) => (ch === "push" ? "Push" : ch === "wallet" ? "Wallet" : ch)).join(" + ");
};
